import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";
import { Classification } from "@/src/models/constants/classifications";
import { ImagingResults } from "@/src/models/documents/imaging/imaging-results";

/** Table row shape: the ImagingResults model plus the section classification the row came from. */
export interface ImagingResultsWithClassification extends ImagingResults {
  classification: Classification;
}
export const imagingResultsQueryParams = {
  imagingResultsClassification: parseAsArrayOf(parseAsString, ","),
  studyType: parseAsArrayOf(parseAsString, ","),
  imagingType: parseAsArrayOf(parseAsString, ","),
  bodyPart: parseAsArrayOf(parseAsString, ","),
  needsSignature: parseAsArrayOf(parseAsString, ",")
};
export function useImagingResultsColumnFilters() {
  return useQueryStates(imagingResultsQueryParams);
}